  import React, { Component, useState, useEffect } from 'react';
  import ReactDOM from "react-dom";
  import { useForm } from "react-hook-form";
  import Header from "../Landingpagecomponents/Header/header"
  import { Grid, Typography, Paper, CircularProgress } from "@material-ui/core";
  import Box from '@material-ui/core/Box';
  import { makeStyles, withStyles } from "@material-ui/core/styles";
  import Button from "@material-ui/core/Button";
  import Slide from "react-reveal/Slide";
  import CreateIcon from '@material-ui/icons/Create';
  import IconButton from '@material-ui/core/IconButton';
  import logo7 from "../Landingpagecomponents/images/logo7.png"
  import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
  import YesNoQuestion from "./questiontypes/yesNoQuestion";
  import PictureChoice from "./questiontypes/pictureChoice";
  import MultipleChoice from "./questiontypes/multipleChoice"
  import DropDownList from "./questiontypes/dropDownList"
  import Question from "./question"
  import InputLabel from '@material-ui/core/InputLabel';
  import Skeleton from "@material-ui/lab/Skeleton";
  import { appendVideoconsultationSummaryToParams } from '../Landingpagecomponents/Content/videoconsultationSummary';

  const PUBLIC_MATCH_SPECIALITY_MAP = {
    a: ['neck', 'headache'],
    b: ['shoulder'],
    c: ['shoulder'],
    d: ['shoulder'],
    e: ['lower_back'],
    f: ['upper_back'],
    g: ['hip', 'thigh'],
    h: ['knee'],
    i: ['ankle', 'foot'],
    k: ['concussion', 'headache'],
  };

  const derivePublicMatchSpecialities = (entries = []) => {
    const bodyAreaAnswer = entries.find((entry) => entry.identifier === 'whatCanWeHelpYouWith');
    if (!bodyAreaAnswer) {
      return [];
    }

    return PUBLIC_MATCH_SPECIALITY_MAP[bodyAreaAnswer.answer] || [];
  };


  function Assessment(props) {
    
    let { register, handleSubmit } = useForm();
    const [isStarted, setIsStarted] = useState(false);
    //const [currentSelectedAnswer, setCurrentSelectedAnswer] = useState(null)
    const [currentQuestionData, setCurrentQuestionData] = useState(null)
    const [questionQuery, setQuestionQuery] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [isShortForm, setIsShortForm] = useState(false);
    const [isExistingFullIntro, setIsExistingFullIntro] = useState(false);
    const [sessionStatusError, setSessionStatusError] = useState(null);
    const assessmentParams = new URLSearchParams(window.location.search);
    const isProviderAssessmentLink = (
      assessmentParams.has('session_id')
      || assessmentParams.has('treatment_id')
      || assessmentParams.get('provider_link') === 'true'
    );
    const isPhysiotherapistMatchFlow = assessmentParams.get('public_booking') === 'true';
    const startMessage = isProviderAssessmentLink
      ? 'Your physiotherapist has requested that you answer a few questions and complete guided tests to prepare for your appointment.'
      : isPhysiotherapistMatchFlow
        ? 'Answer a few questions and complete guided self-tests so we can understand your symptoms and match you with the right physiotherapist.'
        : 'Please complete the following questions and guided tests in order to map your symptoms, and match you with the right physiotherapist.';

    // Local intro question for existing patients on full assessment links
    const existingFullIntroQuestion = {
      identifier: "existingPatientFullIntro",
      questionType: "multipleChoice",
      question: "You've been added by your physiotherapist. We'll guide you through a full assessment to prepare your treatment. This takes about 10–15 minutes.",
      metaJournalPhrase: "",
      answers: [
        {
          id: "a",
          text: "I understand",
          type: "SimpelAnswer",
          journalPhrase: "",
          journalPriority: 70,
          subgroup: "SimpelAnswer"
        }
      ],
      tags: ["intro"],
      journalPriority: 10
    };

    const validateAssessmentSession = async (sessionId) => {
      try {
        const response = await fetch(`https://api.virtus-one.com/question-handler/session/${sessionId}/status/`);
        const payload = await response.json().catch(() => ({}));

        if (response.ok && payload.valid) {
          setSessionStatusError(null);
          return true;
        }

        if (response.status === 410 || payload.reason === 'expired') {
          setSessionStatusError('This assessment link has expired. Please contact your clinic if you still need to complete your intake.');
          return false;
        }

        if (response.status === 404 || payload.reason === 'session_not_found') {
          setSessionStatusError('This assessment link is no longer available. Please request a new link from your clinic.');
          return false;
        }

        setSessionStatusError('We could not validate this assessment link right now. Please try again shortly.');
        return false;
      } catch (error) {
        setSessionStatusError('We could not validate this assessment link right now. Please try again shortly.');
        return false;
      }
    }

    //Henter næste spørgsmål fra database ud fra spørgsmål der ligger i query og logik
    const fetchNextQuestion = async (query, forceShortForm = false) => {
      setIsLoading(true)
      // Detect short_form parameter from URL
      const params = new URLSearchParams(window.location.search);
      const urlShortForm = params.get('short_form') === 'true';
      const sessionIdParam = params.get('session_id');
      const treatmentIdParam = params.get('treatment_id');
      const providerLinkParam = params.get('provider_link') === 'true';
      const publicBookingParam = params.get('public_booking') === 'true';
      const shortFormParam = forceShortForm || urlShortForm;
      const userIdParam = params.get('user_id');  // Extract user_id from URL
      
      //console.log("[Assessment] fetchNextQuestion called:", { forceShortForm, urlShortForm, shortFormParam, userIdParam });
      
      if (!isShortForm && shortFormParam) {
        setIsShortForm(true);
      }

      const requestBody = query.length > 0 ? {
        data: query,
        status: "RUNNING"
      } : {
        data: null,
        status: shortFormParam ? "SHORT_FORM_START" : "START"
      };
      
      // Add user_id if present (for manually added patients)
      if (userIdParam) {
        requestBody.user_id = userIdParam;
      }

      // Attach session/treatment so backend can scope assessments to the right treatment
      if (sessionIdParam) {
        requestBody.session_id = sessionIdParam;
      }
      if (treatmentIdParam) {
        requestBody.treatment_id = treatmentIdParam;
      }
      // Pass through provider_link flag so backend knows to skip checkout for careprovider links
      if (providerLinkParam) {
        requestBody.provider_link = providerLinkParam;
      }
      if (publicBookingParam) {
        requestBody.public_booking = true;
      }

      //console.log("[Assessment] Sending request:", requestBody);

      const response = await fetch("https://api.virtus-one.com/question-handler/submit-query", {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })

      if (response.ok) {
        const data = await response.json()
        //console.log("[Assessment] Received question:", data.question.identifier);
        const q = data.question;
        // If this question has a pre-stored CV answer (from dual-side capture),
        // answer it transparently without showing it to the patient.
        const prefillKey = q?.identifier ? `cv_dual_prefill:${q.identifier}` : null;
        const prefillRaw = prefillKey ? localStorage.getItem(prefillKey) : null;
        if (prefillRaw) {
          try {
            const prefill = JSON.parse(prefillRaw);
            if (prefill?.answerId) {
              localStorage.removeItem(prefillKey);
              const autoQuery = query.concat([{ id: q.id, answer: prefill.answerId }]);
              setQuestionQuery(autoQuery);
              await fetchNextQuestion(autoQuery);
              setIsLoading(false);
              return;
            }
          } catch (e) { /* malformed prefill — fall through and show the question */ }
        }
        setCurrentQuestionData(q)
        setIsLoading(false)
        return data;

      } else {
        //display error
      }
      setIsLoading(false)
      return null;
    }

    // Auto-start short form assessment on mount
    useEffect(() => {
      //console.log("[Assessment] Component mounted, full URL:", window.location.href);
      //console.log("[Assessment] window.location.search:", window.location.search);
      
      const params = new URLSearchParams(window.location.search);
      //console.log("[Assessment] URLSearchParams all entries:", Array.from(params.entries()));
      const shortFormParam = params.get('short_form') === 'true';
      const treatmentIdParam = params.get('treatment_id');
      const sessionIdParam = params.get('session_id');
      
      //console.log("[Assessment] Short form detected:", shortFormParam);
      
      let isMounted = true;

      const bootstrapAssessment = async () => {
        if (sessionIdParam) {
          const isValidSession = await validateAssessmentSession(sessionIdParam);
          if (!isMounted || !isValidSession) {
            return;
          }
        }

        if (shortFormParam) {
          //console.log("[Assessment] Short form detected, auto-starting...");
          setIsShortForm(true);
          setIsStarted(true);
          fetchNextQuestion([], true);
        }
      };

      bootstrapAssessment();

      return () => {
        isMounted = false;
      };
    }, []); // Empty dependency array = run once on mount

  //sletmig igen
    const useStyles = makeStyles((theme) => ({
      root: {
        flexGrow: 1,
        padding: theme.spacing(0),
      },
      responsive: {
        width: "100%",
        height: "auto",
      },
    }));

    const ActionButton = withStyles({
      root: {
        boxShadow: "none",
        textTransform: "none",
        fontSize: 20,
        padding: "0px 40px",
        border: "1px solid",
        lineHeight: 0.5,
        backgroundColor: "#fb741a",
        borderColor: "#fb741a",
        fontFamily: [
          "-apple-system",
          "BlinkMacSystemFont",
          '"Segoe UI"',
          "Roboto",
          '"Helvetica Neue"',
          "Arial",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"'
        ].join(","),
        "&:hover": {
          backgroundColor: "#002D55",
          borderColor: "#002D55",
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none",
          backgroundColor: "#0062cc",
          borderColor: "#005cbf"
        },
        "&:focus": {
          boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
        }
      }
    })(Button);

    const StartItem = <Box
      component="form"
      className="assessment-card-shell"
      onSubmit={handleSubmit(onSubmit)}
      style={{
        width: '100%',
        background: '#f7faff',
        border: '1px solid rgba(0, 45, 85, 0.1)',
        borderRadius: 22,
        padding: 'clamp(20px, 2.4vw, 36px)',
        boxSizing: 'border-box',
        boxShadow: '0 6px 24px rgba(0,45,85,0.08)',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <style>{`
        .assessment-card-shell { max-width: 100%; }
        @media (min-width: 600px) {
          .assessment-card-shell { max-width: 96vw !important; }
        }
        @media (min-width: 960px) {
          .assessment-card-shell { max-width: 92vw !important; }
        }
        @media (min-width: 1280px) {
          .assessment-card-shell { max-width: 88vw !important; }
        }
        @media (min-width: 1920px) {
          .assessment-card-shell { max-width: 1800px !important; }
        }
      `}</style>
        <Typography
          style={{
            color: '#002D55',
            fontSize: 'clamp(18px, 1.6vw, 28px)',
            textAlign: 'center',
            marginBottom: 12,
          }}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <CreateIcon style={{ verticalAlign: 'middle', marginRight: 8, color: '#fb741a' }} />
            <span style={{ verticalAlign: 'middle' }}>Patient Intake Assessment Form</span>
          </span>
        </Typography>
        <Box
          style={{
            borderTop: '1px solid rgba(0, 45, 85, 0.12)',
            marginBottom: 24,
          }}
        />
        <Typography
          variant="body1"
          className="assessment-title-responsive"
          style={{ color: "#002D55", fontWeight: 300, fontSize: "1.1rem", marginBottom: 10, whiteSpace: "pre-line" }}
        >
          <span role="img" aria-label="waving hand" style={{fontSize: "1.5rem", verticalAlign: "middle", marginRight: 8}}>Hi there! 👋</span>
          {`\n${startMessage}`}
          
        </Typography>
        <Typography
          variant="body1"
          className="assessment-title-responsive"
          style={{ color: "#002D55", fontWeight: 300, fontSize: "0.8rem", marginBottom: 10 }}
        >
          Your personal health data will be handled in accordance with EU's General Data Protection Regulation (GDPR).
        </Typography>
        <Typography
          variant="body1"
          className="assessment-title-responsive"
          style={{ color: "#486d86", fontWeight: 300, fontSize: "0.8rem", marginBottom: 24 }}
        >
          Estimated time: 5-10 minutes.
        </Typography>

      <style>{`
        @media (max-width: 600px) {
          .assessment-title-responsive { max-width: 550px; font-size: 1.05rem !important; }
        }
        @media (min-width: 600px) and (max-width: 960px) {
          .assessment-title-responsive { max-width: 550px; font-size: 1.13rem !important; }
        }
        @media (min-width: 960px) and (max-width: 1280px) {
          .assessment-title-responsive { max-width: 570px; font-size: 1.18rem !important; }
        }
        @media (min-width: 1280px) and (max-width: 1920px) {
          .assessment-title-responsive { max-width: 650px; font-size: 1.3rem !important; }
        }
        @media (min-width: 1920px) {
          .assessment-title-responsive { max-width: 700px; font-size: 1.5rem !important; }
        }
      `}</style>

      <ActionButton variant="contained" disableRipple style={{ marginBottom: 5, borderRadius: 24 }}
        onClick={() => {
          setIsStarted(true)
          fetchNextQuestion([])
        }}><h3 className="assessment-button-responsive" style={{fontSize: "1.1rem", margin: 0, padding: 15}}>I UNDERSTAND</h3></ActionButton>
      <style>{`
        @media (max-width: 600px) {
          .assessment-title-responsive { font-size: 0.85rem !important; }
          .assessment-button-responsive { font-size: 0.80rem !important; }
        }
        @media (min-width: 600px) and (max-width: 960px) {
          .assessment-title-responsive { font-size: 0.95rem !important; }
          .assessment-button-responsive { font-size: 0.90rem !important; }
        }
        @media (min-width: 960px) and (max-width: 1280px) {
          .assessment-title-responsive { font-size: 1.0rem !important; }
          .assessment-button-responsive { font-size: 0.9rem !important; }
        }
        @media (min-width: 1280px) and (max-width: 1920px) {
          .assessment-title-responsive { font-size: 1.1rem !important; }
          .assessment-button-responsive { font-size: 1.1rem !important; }
        }
        @media (min-width: 1920px) {
          .assessment-title-responsive { font-size: 1.2rem !important; }
          .assessment-button-responsive { font-size: 1.3rem !important; }
        }
        @media (min-width: 960px) and (max-width: 1280px) {
          .assessment-title-responsive { line-height: 1.35 !important; }
          .assessment-title-responsive br { display: none !important; }
        }
        @media (max-width: 600px) {
          .assessment-logo-responsive { width: 96px !important; }
        }
        @media (min-width: 600px) and (max-width: 960px) {
          .assessment-logo-responsive { width: 108px !important; }
        }
        @media (min-width: 960px) and (max-width: 1280px) {
          .assessment-logo-responsive { width: 120px !important; }
        }
        @media (min-width: 1280px) {
          .assessment-logo-responsive { width: 140px !important; }
        }
      `}</style>
    </Box>;

    const nextQuestionHandler = async (answer, cvResultId) => {
      const hasAnswer = (() => {
        if (answer === null || answer === undefined) return false;
        if (typeof answer === 'string') return answer.replace(/\s/g, '') !== '';
        if (typeof answer === 'number') return true;
        if (typeof answer === 'object') return Object.keys(answer).length > 0;
        return true;
      })();
    
      if (!isLoading && hasAnswer && currentQuestionData != null) {
        // If we're showing the local intro for existing full assessment, don't send it to backend
        if (isExistingFullIntro && currentQuestionData.identifier === 'existingPatientFullIntro') {
          setIsExistingFullIntro(false);
          setIsLoading(true);
          setTimeout(async () => {
            setQuestionQuery([]);
            await fetchNextQuestion([]); // start normal full assessment flow
            setIsLoading(false);
          }, 350);
          return;
        }

        const queryEntry = { "id": currentQuestionData.id, "answer": answer, "identifier": currentQuestionData.identifier };
        // Attach CV result reference when a camera test was completed for this answer
        if (cvResultId) queryEntry.cvResultId = cvResultId;
        var newQuery = questionQuery.concat([queryEntry]);
        setIsLoading(true);
      
        // Check if this is the final question (short form end OR provider-linked assessment complete)
        const isAssessmentEnd = currentQuestionData.identifier === 'endJourneyShortForm' || currentQuestionData.identifier === 'AssessmentComplete';
      
        const thinkingPause = questionQuery.length < 10 ? 550 : 1550;
      
        setTimeout(async () => {
          setQuestionQuery(newQuery);
          const responseData = await fetchNextQuestion(newQuery); // Submit the final answer to backend
          const recommendationSummary = responseData?.videoconsultation_summary || null;
          const publicBookingHandoff = responseData?.public_booking_handoff || null;

          if (publicBookingHandoff) {
            const params = new URLSearchParams(window.location.search);
            const isLockedClinicFlow = params.get('lock_clinic') === 'true';
            const isTemporaryTestMode = params.get('temporary_test_mode') === 'true';
            const clinicIdParam = params.get('clinic_id');
            const clinicNameParam = params.get('clinic_name');
            const clinicCityParam = params.get('city');
            const clinicCountryParam = params.get('country');
            const redirectParams = new URLSearchParams();
            const specialities = Array.isArray(publicBookingHandoff.match_specialities) && publicBookingHandoff.match_specialities.length > 0
              ? publicBookingHandoff.match_specialities
              : derivePublicMatchSpecialities(newQuery);

            redirectParams.set('intake_handoff_id', publicBookingHandoff.id);
            if (specialities.length > 0) {
              redirectParams.set('specialities', specialities.join(','));
            }
            if (isTemporaryTestMode) {
              redirectParams.set('temporary_test_mode', 'true');
            }
            appendVideoconsultationSummaryToParams(
              redirectParams,
              publicBookingHandoff.videoconsultation_summary || recommendationSummary,
            );

            if (isLockedClinicFlow && clinicIdParam) {
              redirectParams.set('clinic_id', clinicIdParam);
              redirectParams.set('lock_clinic', 'true');
              if (clinicNameParam) {
                redirectParams.set('clinic_name', clinicNameParam);
              }
              if (clinicCityParam) {
                redirectParams.set('city', clinicCityParam);
              }
              if (clinicCountryParam) {
                redirectParams.set('country', clinicCountryParam);
              }

              window.location.href = `/public/booking?${redirectParams.toString()}`;
              return;
            }

            window.location.href = `/public/match?${redirectParams.toString()}`;
            return;
          }
          
          // AFTER backend processes it, navigate away if assessment is complete
          if (isAssessmentEnd) {
            const params = new URLSearchParams(window.location.search);
            const isPublicBookingFlow = params.get('public_booking') === 'true';
            const isBookingFirstFlow = params.get('booking_first') === 'true';
            const isLockedClinicFlow = params.get('lock_clinic') === 'true';
            const isTemporaryTestMode = params.get('temporary_test_mode') === 'true';
            const sessionIdParam = params.get('session_id');
            const treatmentIdParam = params.get('treatment_id');
            const clinicIdParam = params.get('clinic_id');
            const clinicNameParam = params.get('clinic_name');
            const clinicCityParam = params.get('city');
            const clinicCountryParam = params.get('country');
            const clinicLocationIdParam = params.get('clinic_location_id');
            const locationNameParam = params.get('location_name');
            const slotStartParam = params.get('slot_start');
            const slotEndParam = params.get('slot_end');

            if (isPublicBookingFlow && !isBookingFirstFlow) {
              const redirectParams = new URLSearchParams();
              const specialities = derivePublicMatchSpecialities(newQuery);

              if (sessionIdParam) {
                redirectParams.set('session_id', sessionIdParam);
              }
              if (treatmentIdParam) {
                redirectParams.set('treatment_id', treatmentIdParam);
              }
              if (specialities.length > 0) {
                redirectParams.set('specialities', specialities.join(','));
              }
              if (isTemporaryTestMode) {
                redirectParams.set('temporary_test_mode', 'true');
              }
              appendVideoconsultationSummaryToParams(redirectParams, recommendationSummary);

              if (isLockedClinicFlow && clinicIdParam) {
                redirectParams.set('clinic_id', clinicIdParam);
                redirectParams.set('lock_clinic', 'true');
                if (clinicNameParam) {
                  redirectParams.set('clinic_name', clinicNameParam);
                }
                if (clinicCityParam) {
                  redirectParams.set('city', clinicCityParam);
                }
                if (clinicCountryParam) {
                  redirectParams.set('country', clinicCountryParam);
                }
                if (clinicLocationIdParam) {
                  redirectParams.set('clinic_location_id', clinicLocationIdParam);
                }
                if (locationNameParam) {
                  redirectParams.set('location_name', locationNameParam);
                }
                if (slotStartParam) {
                  redirectParams.set('slot_start', slotStartParam);
                }
                if (slotEndParam) {
                  redirectParams.set('slot_end', slotEndParam);
                }
                appendVideoconsultationSummaryToParams(redirectParams, recommendationSummary);

                console.log('[Assessment] Clinic-locked assessment completed, navigating directly to public booking...');
                window.location.href = `/public/booking?${redirectParams.toString()}`;
                return;
              }

              const redirectQuery = redirectParams.toString();
              console.log('[Assessment] Assessment completed, navigating to public provider match...');
              window.location.href = `/public/match${redirectQuery ? `?${redirectQuery}` : ''}`;
              return;
            }

            if (isPublicBookingFlow && isBookingFirstFlow) {
              const redirectParams = new URLSearchParams();
              const clinicId = params.get('clinic_id');
              const clinicName = params.get('clinic_name');
              const clinicCity = params.get('city');
              const clinicCountry = params.get('country');
              const slotStart = params.get('slot_start');
              const slotEnd = params.get('slot_end');
              const locationName = params.get('location_name');
              const clinicLocationId = params.get('clinic_location_id');

              redirectParams.set('assessment_complete', 'true');
              if (clinicId) {
                redirectParams.set('clinic_id', clinicId);
              }
              if (clinicName) {
                redirectParams.set('clinic_name', clinicName);
              }
              if (clinicCity) {
                redirectParams.set('city', clinicCity);
              }
              if (clinicCountry) {
                redirectParams.set('country', clinicCountry);
              }
              if (clinicLocationId) {
                redirectParams.set('clinic_location_id', clinicLocationId);
              }
              if (slotStart) {
                redirectParams.set('slot_start', slotStart);
              }
              if (slotEnd) {
                redirectParams.set('slot_end', slotEnd);
              }
              if (locationName) {
                redirectParams.set('location_name', locationName);
              }
              if (isLockedClinicFlow && clinicId) {
                redirectParams.set('lock_clinic', 'true');
              }
              if (isTemporaryTestMode) {
                redirectParams.set('temporary_test_mode', 'true');
              }
              appendVideoconsultationSummaryToParams(redirectParams, recommendationSummary);

              console.log('[Assessment] Booking-first test flow completed, navigating to booking confirmation shell...');
              window.location.href = `/public/booking?${redirectParams.toString()}`;
              return;
            }

            console.log('[Assessment] Assessment completed, navigating to landing page...');
            window.location.href = '/';
            return;
          }
          
          setIsLoading(false);
        }, thinkingPause);
      }
    };

    //Fjerner 1 objekt fra query listen i backen og fetcher newQuery igen
    const previousQuestionHandler = () => {
      if (!isLoading) {
        var newQuery = questionQuery.slice(0, questionQuery.length - 1);
        setQuestionQuery(newQuery)
        fetchNextQuestion(newQuery)
      }
    }

    //Kalder question function med de forskellige questiontypes afhængig af spørgeskemalogik
    const LoadingSkeleton = (
      <div style={{ width: '100%', borderRadius: 12, background: '#e0e3e8', minHeight: 220, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={32} style={{ color: '#7a9bbf' }} />
      </div>
    );

    const AssessmentFooter = (
      <Grid
        container
        direction="row"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%"
        }}
      >
        {isLoading ? (
          <>
            <style>
              {`
                @keyframes pulseText {
                  0% { opacity: 1; }
                  50% { opacity: 0.4; }
                  100% { opacity: 1; }
                }
              `}
            </style>
            <Grid
              container
              direction="row"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                marginTop: 15,
              }}
            >
              <Typography
                style={{
                  marginLeft: 0,
                  color: "#fb741a",
                  fontSize: 20,
                  fontWeight: 600,
                  animation: "pulseText 1s infinite"
                }}
              >
                {/* Thinking */}
              </Typography>
              <Skeleton variant="circular" width={8} height={8} animation="pulse" style={{ margin: "0 8px", marginBottom: 5, background: "#fb741a" }} />
              <Skeleton variant="circular" width={8} height={8} animation="pulse" style={{ margin: "0 8px", marginBottom: 5, background: "#fb741a" }} />
              <Skeleton variant="circular" width={8} height={8} animation="pulse" style={{ margin: "0 8px", marginBottom: 5, background: "#fb741a" }} />
            </Grid>
          </>
        ) : !sessionStatusError && (
          <Button
          style={{
            color: "#002D55",
            borderColor: "#002D55",
            border: "1px solid #002D55",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 12,
            borderRadius: 999,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "clamp(13px, 0.9vw, 15px)",
            padding: "0 16px",
            height: 36.5,
            minHeight: 36.5,
            lineHeight: 1,
          }}
          className="assessment-button-responsive"
            onClick={previousQuestionHandler}
          >
            Back
          </Button>
        )}
      </Grid>
    );

    const AssessmentQuestionCard = ({ children }) => (
      <Box
        className="assessment-card-shell"
        style={{
          width: '100%',
          background: '#f7faff',
          border: '1px solid rgba(0, 45, 85, 0.1)',
          borderRadius: 22,
          padding: 'clamp(20px, 2.4vw, 36px)',
          boxSizing: 'border-box',
          boxShadow: '0 6px 24px rgba(0,45,85,0.08)',
        }}
      >
        <style>{`
          .assessment-card-shell { max-width: 100%; }
          @media (min-width: 600px) {
            .assessment-card-shell { max-width: 96vw !important; }
          }
          @media (min-width: 960px) {
            .assessment-card-shell { max-width: 92vw !important; }
          }
          @media (min-width: 1280px) {
            .assessment-card-shell { max-width: 88vw !important; }
          }
          @media (min-width: 1920px) {
            .assessment-card-shell { max-width: 1800px !important; }
          }
        `}</style>
        {children}
        {AssessmentFooter}
      </Box>
    );

    const ViewItem = !isStarted ? StartItem : (
      currentQuestionData ? (
        <AssessmentQuestionCard>
          <Question
            questionData={currentQuestionData}
            nextQuestionHandler={nextQuestionHandler}
            questionClassName="assessment-question-responsive"
          />
        </AssessmentQuestionCard>
      ) : LoadingSkeleton
    )

    const SessionStatusErrorView = (
      <div style={{ textAlign: 'center', maxWidth: 560, padding: '24px 12px' }}>
        <Typography
          variant="h6"
          className="assessment-title-responsive"
          style={{ color: '#002D55', fontWeight: 500, marginBottom: 12 }}
        >
          Assessment unavailable
        </Typography>
        <Typography
          variant="body1"
          className="assessment-title-responsive"
          style={{ color: '#486d86', fontWeight: 300, fontSize: '1rem' }}
        >
          {sessionStatusError}
        </Typography>
      </div>
    );

    const RenderedContent = sessionStatusError ? SessionStatusErrorView : ViewItem;

    const handleCloseAssessment = () => {
      window.location.href = '/';
    };

    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        <div
          className="assessment-header"
          style={{
            height: 50,
            maxHeight: 50,
            background: '#fff',
            borderBottom: '1px solid rgba(0, 45, 85, 0.12)',
            boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 11,
            paddingTop: 4,
            position: 'relative',
            zIndex: 10,
          }}
        >
          <img
            src={logo7}
            alt="Virtus Physio"
            style={{ width: 40, height: 40, objectFit: 'contain' }}
          />
        </div>
        <style>{`
          @media (min-width: 1920px) {
            .assessment-header { height: 57px !important; max-height: 57px !important; }
          }
          .assessment-close-wrap {
            position: absolute;
            top: 62px;
            left: 24px;
            z-index: 1000;
            padding: 0;
          }
          @media (min-width: 1920px) {
            .assessment-close-wrap { top: 89px; left: 24px; }
          }
          .assessment-close-btn {
            border-radius: 999px !important;
            background: #ffffff !important;
            color: #000 !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.12) !important;
            padding: 6px !important;
            min-width: 40px !important;
            min-height: 40px !important;
            font-size: 16px !important;
            font-weight: 700 !important;
            transition: background-color 150ms ease, box-shadow 150ms ease !important;
          }
          .assessment-close-btn:hover {
            background-color: rgba(0, 45, 85, 0.12) !important;
            box-shadow: 0 2px 10px rgba(0, 45, 85, 0.18) !important;
          }
        `}</style>
        <div
          className="assessment-close-wrap"
          style={{
          }}
        >
          <IconButton
            className="assessment-close-btn"
            onClick={handleCloseAssessment}
          >
            <span style={{ fontSize: 'clamp(12px, 1vw, 18px)', fontWeight: 500, lineHeight: 1, paddingTop: 2 }}>X</span>
          </IconButton>
        </div>
      <Grid
        container
        style={{
          background: "linear-gradient(90deg, #dce4eb, #d7d4cf)",
          minHeight: "calc(100vh - 50px)",
          alignItems: "center",
          justifyContent: "center",
          padding: 12,
          paddingTop: 28
        }}
        className="assessment-root-zoom"
      >
        <style>{`
          @media (min-width: 600px) {
            .assessment-root-zoom { zoom: 0.88; }
          }
          @media (min-width: 1920px) {
            .assessment-root-zoom { zoom: 0.93; }
          }
          @media (min-width: 2560px) {
            .assessment-root-zoom { zoom: 0.98; }
          }
        `}</style>
        <Paper
          elevation={3}
          style={{
            background: "transparent",
            borderRadius: 40,
            padding: 16,
            marginLeft: 10,
            marginRight: 10,
            marginTop: 10,
            marginBottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            transition: "min-height 0.2s, width 0.2s"
          }}
        >
          <style>{`
            @media (max-width: 600px) {
              .assessment-question-responsive { font-size: 1.05rem !important; }
              .assessment-button-responsive { font-size: 0.80rem !important; }
            }
            @media (min-width: 600px) and (max-width: 960px) {
              .assessment-question-responsive { font-size: 1.13rem !important; }
              .assessment-button-responsive { font-size: 0.90rem !important; }
            }
            @media (min-width: 960px) and (max-width: 1280px) {
              .assessment-question-responsive { font-size: 1.18rem !important; }
              .assessment-button-responsive { font-size: 0.9rem !important; }
            }
            @media (min-width: 1280px) and (max-width: 1920px) {
              .assessment-question-responsive { font-size: 1.3rem !important; }
              .assessment-button-responsive { font-size: 1.1rem !important; }
            }
            @media (min-width: 1920px) {
              .assessment-question-responsive { font-size: 1.5rem !important; }
              .assessment-button-responsive { font-size: 1.3rem !important; }
            }
          `}</style>
          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {RenderedContent}
          </div>
        </Paper>
      </Grid>
      </div>
    );
  }

  function onSubmit(values) {
    console.log(values)
  }

  export default Assessment;

  //<iframe width="100%" height="1200" src="https://virtusphysio.typeform.com/to/G9rBQl" frameborder="0" allowfullscreen></iframe>

  //<div>
  //<label>First name</label><br />
  //<input type="text" name="firstname" id="firstname"/><br /><br />
  //</div>